import { render, staticRenderFns } from "./spread.vue?vue&type=template&id=87317d04&"
import script from "./spread.vue?vue&type=script&lang=js&"
export * from "./spread.vue?vue&type=script&lang=js&"
import style0 from "./spread.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports